export const LANG_PREF_COOKIE = 'db-lang-pref'

export function getLangPrefCookie(): string | null {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${LANG_PREF_COOKIE}=([^;]+)`),
  )
  return match ? decodeURIComponent(match[1]) : null
}

export function setLangPrefCookie(code: string): void {
  if (typeof document === 'undefined') return
  const maxAge = 365 * 24 * 60 * 60
  document.cookie = `${LANG_PREF_COOKIE}=${encodeURIComponent(code)};max-age=${maxAge};path=/;SameSite=Lax`
}

export function getCookieValue(name: string): string | null {
  if (typeof document === 'undefined') return null
  const match = document.cookie.match(
    new RegExp(`(?:^|;\\s*)${encodeURIComponent(name)}=([^;]+)`),
  )
  return match ? decodeURIComponent(match[1]) : null
}

function extractLangCode(locale: string): string {
  return locale.split(/[-_]/)[0].toLowerCase()
}

export function detectBrowserLanguage(): string {
  if (typeof navigator === 'undefined') return 'en'
  return extractLangCode(navigator.language ?? 'en')
}

export function detectSystemLanguage(): string {
  if (typeof navigator === 'undefined') return 'en'
  const langs = navigator.languages
  if (langs && langs.length > 0) return extractLangCode(langs[0])
  return extractLangCode(navigator.language ?? 'en')
}

// Spanish-speaking timezones (Latin America + Spain)
const SPANISH_TZ_RE =
  /^America\/(Mexico_City|Bogota|Lima|Santiago|Buenos_Aires|Caracas|La_Paz|Asuncion|Montevideo|Guayaquil|Managua|Guatemala|Tegucigalpa|San_Salvador|Costa_Rica|Panama|Havana|Santo_Domingo|Cancun)|^Europe\/Madrid/

export function detectSmartLanguage(): string {
  try {
    const resolved = Intl.DateTimeFormat().resolvedOptions()
    if (SPANISH_TZ_RE.test(resolved.timeZone ?? '')) return 'es'
    return extractLangCode(resolved.locale ?? navigator.language ?? 'en') || 'en'
  } catch {
    return detectBrowserLanguage()
  }
}

export function detectPreferredLanguage(
  method: 'browser' | 'system' | 'smart',
): string {
  if (method === 'system') return detectSystemLanguage()
  if (method === 'smart') return detectSmartLanguage()
  return detectBrowserLanguage()
}
